import React from "react";

/**
 * A simple nav wrapper that is meant to have a left, middle, and right component.
 */
const Nav = ({
  children,
  hide,
}: {
  hide?: boolean | null;
  children: React.ReactNode;
}): React.ReactElement => (
  <header className={`z-50  bg-white flex justify-center sticky top-0 px-5 py-2 w-full h-[60px]`}>
    <nav className={`flex justify-between items-center w-full gap-2 ${hide ? "invisible" : ""}`}>
      {children}
    </nav>
  </header>
);

export default React.memo(Nav);
